import delv from 'dlv';

import { Service } from './types';

export default class ApiKeys {
  static get(service: Service, fallback: string = ''): string {
    return delv(process.env, this.getApiKeyEnvName(service), fallback);
  }

  private static getApiKeyEnvName(service: Service) {
    return `REACT_APP_RBI_${service}_KEY`;
  }
}
